import React from "react";
import { Tweet } from "react-tweet";
import "../css/tweetlist.css";

const tweets = [
  "1947230694272323803" ,
  "1945356923714289966" ,
  "1939609989418491975" ,
  "1901871339834667224" ,
  "1903401274797621269" ,
  
  "1883137756244910326",
  "1883766962050023744", 
  "1883141494095434191",
  "1888530482792378689"
];

const TweetList = () => {
  return (
    <section className="tweet-section">
      <div className="section-header">
        <h2 className="section-subtitle">Social Buzz</h2>
        <h1 className="section-title">
          <span className="title-highlight">EnergyX Africa</span> on Twitter
        </h1>
        <div className="divider"></div>
        <p className="section-description">
       See what people are saying at our breathrough industry initiative connecting Southern Africa's just energy transition future

        </p>
      </div>
      
      <div className="tweet-grid">
        {tweets.map((tweetId) => (
          <div key={tweetId} className="tweet-card">
            <div className="tweet-content">
              <Tweet id={tweetId} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TweetList;